// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__ImnJH","actions":"GroupTable_actions__2XeVX","deleteModalFooter":"GroupTable_deleteModalFooter__2ehtG"};